/* Takımını oluştur: parça adetleri, canlı toplam, sepete ekleme. Fiyat = parçaların toplamı. */
if (!customElements.get('takim-olustur')) {
  class TakimOlustur extends HTMLElement {
    connectedCallback() {
      this.parcalar = [...this.querySelectorAll('.takim__parca')].map((li) => ({
        li,
        title: li.dataset.title,
        variantId: Number(li.dataset.variantId),
        price: Number(li.dataset.price),
        adet: Number(li.dataset.adet) || 0,
        out: li.querySelector('output'),
        azalt: li.querySelector('[data-azalt]'),
        birim: li.querySelector('.takim__birim'),
      }));
      this.secimEl = this.querySelector('.takim__secim');
      this.toplamEl = this.querySelector('.takim__toplam');
      this.hataEl = this.querySelector('.takim__hata');
      this.waEl = this.querySelector('[data-wa]');
      this.sepeteBtn = this.querySelector('[data-sepete]');
      this.hemenBtn = this.querySelector('[data-hemen]');

      this.parcalar.forEach((p) => {
        p.li.querySelector('[data-arttir]').addEventListener('click', () => this.degistir(p, 1));
        p.azalt.addEventListener('click', () => this.degistir(p, -1));
        const sel = p.li.querySelector('.takim__varyant');
        if (sel) {
          sel.addEventListener('change', () => {
            const opt = sel.selectedOptions[0];
            p.variantId = Number(opt.value);
            p.price = Number(opt.dataset.price);
            this.guncelle();
          });
        }
      });
      this.sepeteBtn.addEventListener('click', () => this.ekle(false));
      this.hemenBtn.addEventListener('click', () => this.ekle(true));
      this.guncelle();
    }

    degistir(p, d) {
      p.adet = Math.max(0, Math.min(9, p.adet + d));
      this.guncelle();
    }

    para(cents) {
      const fmt = this.dataset.moneyFormat || '{{amount}} TL';
      const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      const sep = (n, dec, th, dp) => {
        const [a, b] = (n / 100).toFixed(dec).split('.');
        return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? dp + b : '');
      };
      const kind = m ? m[1] : 'amount';
      const table = {
        amount: () => sep(cents, 2, ',', '.'),
        amount_no_decimals: () => sep(cents, 0, ',', '.'),
        amount_with_comma_separator: () => sep(cents, 2, '.', ','),
        amount_no_decimals_with_comma_separator: () => sep(cents, 0, '.', ','),
        amount_with_space_separator: () => sep(cents, 2, ' ', ','),
        amount_no_decimals_with_space_separator: () => sep(cents, 0, ' ', ','),
        amount_with_period_and_space_separator: () => sep(cents, 2, ' ', '.'),
      };
      const value = (table[kind] || table.amount)();
      return m ? fmt.replace(m[0], value) : value;
    }

    secilenler() {
      return this.parcalar.filter((p) => p.adet > 0);
    }

    kisaAd(p) {
      // "Line Üçlü Koltuk" -> "Üçlü Koltuk": ortak seri adını özetten çıkarır
      const seri = this.dataset.takim.split(' ')[0];
      return p.title.startsWith(seri + ' ') ? p.title.slice(seri.length + 1) : p.title;
    }

    guncelle() {
      let toplam = 0;
      this.parcalar.forEach((p) => {
        p.out.value = p.adet;
        p.out.textContent = p.adet;
        p.azalt.disabled = p.adet === 0;
        p.li.toggleAttribute('data-bos', p.adet === 0);
        if (p.birim) p.birim.textContent = this.para(p.price);
        toplam += p.adet * p.price;
      });
      const sec = this.secilenler();
      const ozet = sec.map((p) => `${p.adet} ${this.kisaAd(p)}`).join(' + ');
      this.secimEl.textContent = sec.length ? `Seçiminiz: ${ozet}` : 'Henüz parça seçmediniz';
      this.toplamEl.textContent = this.para(toplam);
      [this.sepeteBtn, this.hemenBtn].forEach((b) => b.toggleAttribute('aria-disabled', !sec.length));
      if (sec.length) [this.sepeteBtn, this.hemenBtn].forEach((b) => b.removeAttribute('aria-disabled'));

      // Sayfanın ana fiyatı da seçime göre değişsin
      const priceBox = document.getElementById(`price-${this.dataset.section}`);
      if (priceBox) {
        priceBox.querySelectorAll('.f-price').forEach((el) => el.classList.remove('f-price--on-sale'));
        priceBox.querySelectorAll('.f-price__regular .f-price-item--regular').forEach((el) => {
          el.textContent = this.para(toplam);
        });
      }

      const mesaj = `Merhaba, ${this.dataset.takim} için şu seçimle fiyat ve teslimat bilgisi alabilir miyim?\n${sec
        .map((p) => `- ${p.adet} x ${p.title}`)
        .join('\n')}\nToplam: ${this.para(toplam)}\n${location.origin}${location.pathname}`;
      this.waEl.href = `https://wa.me/${this.dataset.whatsapp}?text=${encodeURIComponent(mesaj)}`;
    }

    hata(msg) {
      this.hataEl.hidden = !msg;
      this.hataEl.textContent = msg || '';
    }

    async ekle(hemen) {
      const sec = this.secilenler();
      if (!sec.length) return;
      const btn = hemen ? this.hemenBtn : this.sepeteBtn;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('btn--loading');
      this.hata('');

      const ozet = sec.map((p) => `${p.adet} ${this.kisaAd(p)}`).join(' + ');
      const kumasEl = this.querySelector('[data-kumas-tercihi]');
      const kumas = kumasEl ? kumasEl.value.trim() : '';
      const items = sec.map((p) => {
        const properties = { Takım: `${this.dataset.takim} (${ozet})` };
        if (kumas) properties['Kumaş / renk'] = kumas;
        return { id: p.variantId, quantity: p.adet, properties };
      });
      const sections = [];
      if (!hemen) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
        );
      }
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const body = { items };
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = location.pathname;
        }
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi');

        if (hemen) {
          location.href = `${root}checkout`;
          return;
        }
        const ft = window.FoxTheme;
        if (ft && ft.pubsub && ft.settings && ft.settings.cartType !== 'page') {
          const cart = await (await fetch(`${root}cart.js`)).json();
          cart.sections = data.sections;
          ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.show) drawer.show(btn);
          else location.href = `${root}cart`;
        } else {
          location.href = `${root}cart`;
        }
      } catch (e) {
        this.hata(`${e.message}. Lütfen tekrar deneyin ya da WhatsApp'tan bize yazın.`);
      } finally {
        btn.classList.remove('btn--loading');
        btn.removeAttribute('aria-disabled');
      }
    }
  }
  customElements.define('takim-olustur', TakimOlustur);
}
